import type { TimeSeriesData } from '../types';

export type TimeSeriesExtent = {
  minTimestamp: number;
  maxTimestamp: number;
  minValue: number;
  maxValue: number;
};

/** Finds the timestamp and value bounds of time-series data in one pass. */
export function getTimeSeriesExtent<T extends TimeSeriesData>(
  data: readonly T[],
  getPointMin: (point: T) => number,
  getPointMax: (point: T) => number = getPointMin,
): TimeSeriesExtent | undefined {
  const firstPoint = data[0];
  if (!firstPoint) return undefined;

  const { timestamp: firstTimestamp } = firstPoint;
  const firstMinValue = getPointMin(firstPoint);
  const firstMaxValue = getPointMax(firstPoint);
  let minTimestamp = firstTimestamp;
  let maxTimestamp = firstTimestamp;
  let minValue = firstMinValue;
  let maxValue = firstMaxValue;

  for (let index = 1; index < data.length; index++) {
    const point = data[index];
    const { timestamp } = point;
    minTimestamp = Math.min(minTimestamp, timestamp);
    maxTimestamp = Math.max(maxTimestamp, timestamp);
    minValue = Math.min(minValue, getPointMin(point));
    maxValue = Math.max(maxValue, getPointMax(point));
  }

  return { minTimestamp, maxTimestamp, minValue, maxValue };
}
